import { render, staticRenderFns } from "./ForgetPass.vue?vue&type=template&id=79c014cc&scoped=true&"
import script from "./ForgetPass.vue?vue&type=script&lang=js&"
export * from "./ForgetPass.vue?vue&type=script&lang=js&"
import style0 from "./ForgetPass.vue?vue&type=style&index=0&id=79c014cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c014cc",
  null
  
)

export default component.exports